import { colors } from '@f8n/tokens';
import { styled } from '@f8n-frontend/stitches';

import Button from './base/Button';

type ColorConfig = typeof colors;

const createToneHelperForColor = <Color extends keyof ColorConfig>(
  color: Color
) => {
  return (tone: keyof ColorConfig[Color]) => {
    return `$${color}${String(tone)}`;
  };
};

const createColorTintCss = (color: keyof ColorConfig) => {
  const getTone = createToneHelperForColor(color);

  return {
    backgroundColor: getTone(0),
    color: getTone(5),

    '& strong': {
      color: getTone(4),
    },

    [`& ${Button}`]: {
      color: getTone(5),
      backgroundColor: getTone(1),
    },
  };
};

const ColorTint = styled('div', {
  backgroundColor: '$black3',

  variants: {
    tint: {
      blue: createColorTintCss('blue'),
      purple: createColorTintCss('purple'),
      red: createColorTintCss('red'),
    },
  },
});

export default ColorTint;
